import {
  CALLBACK_DETAIL,
    CALLBACK_DETAIL_API_ERROR,
    CALLBACK_DETAIL_SUCCESS,
    CLEAR_DYNAMIC_PIXEL,
    COUPEN_CODE,
    COUPEN_CODE_API_ERROR,
    COUPEN_CODE_SUCCESS,
    DYNAMIC_PIXEL,
    DYNAMIC_PIXEL_API_ERROR,
    DYNAMIC_PIXEL_SUCCESS,
    MEMBERSHIP_DETAIL, MEMBERSHIP_DETAIL_API_ERROR, 
    MEMBERSHIP_DETAIL_SUCCESS, PAY_NOW, PAY_NOW_SUCCESS,
    OFFLINE_PROFILE,OFFLINE_PROFILE_SUCCESS,OFFLINE_PROFILE_FAIL
  } from "./ActionTypes";


  //membership onload
  export const getMemberShipDetail = (id, email,fromPage ,microtrackId,requestvia,discountCode) => {
    return {
      type: MEMBERSHIP_DETAIL,
      payload: {id, email,fromPage ,microtrackId,requestvia,discountCode}
    };
  };

  export const getMemberShipDetailSuccess = data => {
    return {
      type: MEMBERSHIP_DETAIL_SUCCESS,
      payload: data,
    };
  };
  export const getMemberShipDetailApiError = error => {
    return {
      type: MEMBERSHIP_DETAIL_API_ERROR,
      payload: error,
    };
  };


    //offline onload
 
// export const getOfflineDetail = 
// (id) => {
//   return {
//     type: OFFLINE_PROFILE,
//     payload: "1678208"
//   };
// };
// export const getOfflineDetailSuccess = data => {
//   return {
//     type: OFFLINE_PROFILE_SUCCESS,
//     payload: data,
//   };
// };
// export const getOfflineDetailFail = error => {
//   return {
//     type: OFFLINE_PROFILE_FAIL,
//     payload: error,
//   };
// };


   //call back 
   export const callBackDetail = (values,id) => {
    return {
      type: CALLBACK_DETAIL,
      payload: {values,id}
    };
  };

  export const callBackDetailSuccess = data => {
    return {
      type: CALLBACK_DETAIL_SUCCESS,
      payload: data,
    };
  };
  
  export const callBackDetailApiError = error => {
    return {
      type: CALLBACK_DETAIL_API_ERROR,
      payload: error,
    };
  };

   //cuopen code 
   export const coupenCode = (values, id, discountCode, fromPage) => {
    return {
      type: COUPEN_CODE,
      payload: { values, id, discountCode, fromPage }
    };
  };

  export const coupenCodeSuccess = data => {
    return {
      type: COUPEN_CODE_SUCCESS,
      payload: data,
    };
  };
  
  export const coupenCodeApiError = error => {
    return {
      type: COUPEN_CODE_API_ERROR,
      payload: error,
    };
  };

  //pay now code 
  export const payNow = (values,id, discountCode) => {
    return {
      type: PAY_NOW,
      payload: {values,id, discountCode}
    };
  };

  export const payNowSuccess = data => {
    return {
      type: PAY_NOW_SUCCESS,
      payload: data,
    };
  };
  
  export const payNowApiError = error => {
    return {
      type: PAY_NOW_SUCCESS,
      payload: error,
    };
  };

  //dynamic pixel code 
  export const dynamicPixel = () => {
    return {
      type: DYNAMIC_PIXEL,
      payload: {}
    };
  };

    //dynamic pixel code 
    export const clearDynamicPixel = () => {
      return {
        type: CLEAR_DYNAMIC_PIXEL,
        payload: {}
      };
    };

  export const dynamicPixelSuccess = data => {
    return {
      type: DYNAMIC_PIXEL_SUCCESS,
      payload: data,
    };
  };
  
  export const dynamicPixelApiError = error => {
    return {
      type: DYNAMIC_PIXEL_API_ERROR,
      payload: error,
    };
  };
